import { render } from "./ChamadosAndamentoView.vue?vue&type=template&id=3f5a07d6&scoped=true"
import script from "./ChamadosAndamentoView.vue?vue&type=script&lang=js"
export * from "./ChamadosAndamentoView.vue?vue&type=script&lang=js"

import "./ChamadosAndamentoView.vue?vue&type=style&index=0&id=3f5a07d6&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5a07d6"]])

export default __exports__